<template>
  <div :class="classes">
    <slot :classes="classes"></slot>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  textSans: {
    type: Boolean,
    default: false,
  },
})

// Passed as slot props because dynamic html content still need to be wrapped inside a div
// (that breaks some rules of prose, like the first paragraph not having a margin top)
const classes = computed<string>(() => {
  return `prose prose-shade max-w-none text-mobile-lg prose-headings:font-sans prose-h1:text-mobile-3xl prose-h2:text-mobile-2xl prose-h3:text-mobile-xl prose-a:no-underline hover:prose-a:text-primary-300 prose-figcaption:m-0 prose-figcaption:font-sans prose-figcaption:text-base prose-figcaption:font-semibold prose-pre:whitespace-pre-wrap prose-pre:text-base prose-pre:bg-shade-100 prose-pre:text-shade-800 md:prose-h1:text-3xl md:prose-h2:text-2xl md:prose-h3:text-xl  lg:text-lg ${
    props.textSans ? 'font-sans' : 'font-serif'
  }`
})
</script>
